/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DockerWorkerConfigV2DockerDatasource } from './DockerWorkerConfigV2DockerDatasource';
import { DockerWorkerConfigV2DockerDatasourceFromJSON, DockerWorkerConfigV2DockerDatasourceFromJSONTyped, DockerWorkerConfigV2DockerDatasourceToJSON, } from './DockerWorkerConfigV2DockerDatasource';
import type { DockerWorkerConfigV2DockerObjectLevel } from './DockerWorkerConfigV2DockerObjectLevel';
import { DockerWorkerConfigV2DockerObjectLevelFromJSON, DockerWorkerConfigV2DockerObjectLevelFromJSONTyped, DockerWorkerConfigV2DockerObjectLevelToJSON, } from './DockerWorkerConfigV2DockerObjectLevel';
import type { DockerWorkerConfigV2DockerStoppingCondition } from './DockerWorkerConfigV2DockerStoppingCondition';
import { DockerWorkerConfigV2DockerStoppingConditionFromJSON, DockerWorkerConfigV2DockerStoppingConditionFromJSONTyped, DockerWorkerConfigV2DockerStoppingConditionToJSON, } from './DockerWorkerConfigV2DockerStoppingCondition';
import type { DockerWorkerConfigV3DockerCorruptnessCheck } from './DockerWorkerConfigV3DockerCorruptnessCheck';
import { DockerWorkerConfigV3DockerCorruptnessCheckFromJSON, DockerWorkerConfigV3DockerCorruptnessCheckFromJSONTyped, DockerWorkerConfigV3DockerCorruptnessCheckToJSON, } from './DockerWorkerConfigV3DockerCorruptnessCheck';
import type { LightlyDockerSelectionMethod } from './LightlyDockerSelectionMethod';
import { LightlyDockerSelectionMethodFromJSON, LightlyDockerSelectionMethodFromJSONTyped, LightlyDockerSelectionMethodToJSON, } from './LightlyDockerSelectionMethod';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 * docker run configurations, keys should match the structure of
 * https://github.com/lightly-ai/lightly-core/blob/develop/onprem-docker/lightly_worker/src/lightly_worker/resources/docker/docker.yaml
 * @export
 * @interface DockerWorkerConfigV2Docker
 *
 */
// create custom validators for the regexes
export interface DockerWorkerConfigV2Docker {
    /**
     *
     * #type string
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    checkpoint?: string;
    /**
     *
     * #type DockerWorkerConfigV3DockerCorruptnessCheck
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    corruptnessCheck?: DockerWorkerConfigV3DockerCorruptnessCheck;
    /**
     *
     * #type DockerWorkerConfigV2DockerDatasource
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    datasource?: DockerWorkerConfigV2DockerDatasource;
    /**
     *
     * #type string
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    embeddings?: string;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    enableTraining?: boolean;
    /**
     *
     * #type LightlyDockerSelectionMethod
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    method?: LightlyDockerSelectionMethod;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    normalizeEmbeddings?: boolean;
    /**
     *
     * #type string
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    outputImageFormat?: string;
    /**
     *
     * #type DockerWorkerConfigV2DockerObjectLevel
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    objectLevel?: DockerWorkerConfigV2DockerObjectLevel;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    pretagging?: boolean;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    pretaggingUpload?: boolean;
    /**
     *
     * #type string
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    relevantFilenamesFile?: string;
    /**
     *
     * #type number
     * #memberof DockerWorkerConfigV2Docker
        * @type int
    * @minimum 1
            
         */
    selectedSequenceLength?: number;
    /**
     *
     * #type DockerWorkerConfigV2DockerStoppingCondition
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    stoppingCondition?: DockerWorkerConfigV2DockerStoppingCondition;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV2Docker
        
        
         */
    uploadReport?: boolean;
}
/**
 * Check if a given object implements the DockerWorkerConfigV2Docker interface.
 */
export function instanceOfDockerWorkerConfigV2Docker(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DockerWorkerConfigV2DockerDatasourceValidator, DockerWorkerConfigV2DockerDatasourceStringifyShape, DockerWorkerConfigV2DockerDatasourceStringifyShapeProperties, } from './DockerWorkerConfigV2DockerDatasource';
import { DockerWorkerConfigV2DockerObjectLevelValidator, DockerWorkerConfigV2DockerObjectLevelStringifyShape, DockerWorkerConfigV2DockerObjectLevelStringifyShapeProperties, } from './DockerWorkerConfigV2DockerObjectLevel';
import { DockerWorkerConfigV2DockerStoppingConditionValidator, DockerWorkerConfigV2DockerStoppingConditionStringifyShape, DockerWorkerConfigV2DockerStoppingConditionStringifyShapeProperties, } from './DockerWorkerConfigV2DockerStoppingCondition';
import { DockerWorkerConfigV3DockerCorruptnessCheckValidator, DockerWorkerConfigV3DockerCorruptnessCheckStringifyShape, DockerWorkerConfigV3DockerCorruptnessCheckStringifyShapeProperties, } from './DockerWorkerConfigV3DockerCorruptnessCheck';
import { LightlyDockerSelectionMethodValidator, LightlyDockerSelectionMethodStringifyShape, LightlyDockerSelectionMethodStringifyShapeProperties, } from './LightlyDockerSelectionMethod';
export const DockerWorkerConfigV2DockerTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerWorkerConfigV2Docker => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerWorkerConfigV2Docker => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io1(input.corruptnessCheck, true && _exceptionable)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io2(input.datasource, true && _exceptionable)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.method || "coreset" === input.method || "random" === input.method) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.objectLevel || "object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) && $io3(input.objectLevel, true && _exceptionable)) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io4(input.stoppingCondition, true && _exceptionable)) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["checkpoint", "corruptnessCheck", "datasource", "embeddings", "enableTraining", "method", "normalizeEmbeddings", "outputImageFormat", "objectLevel", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "stoppingCondition", "uploadReport"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["corruptionThreshold"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["bypassVerify", "enableDatapoolUpdate", "processAll"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io3 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName)) && (undefined === input.padding || "number" === typeof input.padding) && (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["cropDatasetName", "padding", "taskName"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io4 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance) && (undefined === input.nSamples || "number" === typeof input.nSamples) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["minDistance", "nSamples"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV2Docker => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao1(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao2(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.method || "coreset" === input.method || "random" === input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "(\"coreset\" | \"random\" | undefined)",
                    value: input.method
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.objectLevel || ("object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && $ao3(input.objectLevel, _path + ".objectLevel", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.stoppingCondition || ("object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && $ao4(input.stoppingCondition, _path + ".stoppingCondition", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["checkpoint", "corruptnessCheck", "datasource", "embeddings", "enableTraining", "method", "normalizeEmbeddings", "outputImageFormat", "objectLevel", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "stoppingCondition", "uploadReport"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && (0 <= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@minimum 0)",
                    value: input.corruptionThreshold
                })) && (1 >= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@maximum 1)",
                    value: input.corruptionThreshold
                })) || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "(number | undefined)",
                    value: input.corruptionThreshold
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["corruptionThreshold"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["bypassVerify", "enableDatapoolUpdate", "processAll"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName)",
                    value: input.cropDatasetName
                })) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "(string | undefined)",
                    value: input.cropDatasetName
                })) && (undefined === input.padding || "number" === typeof input.padding || $guard(_exceptionable, {
                    path: _path + ".padding",
                    expected: "(number | undefined)",
                    value: input.padding
                })) && (undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["cropDatasetName", "padding", "taskName"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance || $guard(_exceptionable, {
                    path: _path + ".minDistance",
                    expected: "(number | undefined)",
                    value: input.minDistance
                })) && (undefined === input.nSamples || "number" === typeof input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["minDistance", "nSamples"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV2Docker",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV2Docker",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerWorkerConfigV2DockerTypiaAssertStringify = (input: DockerWorkerConfigV2Docker): string => {
    return ((input: any): string => { const assert = (input: any): DockerWorkerConfigV2Docker => {
        const __is = (input: any): input is DockerWorkerConfigV2Docker => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io1(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io2(input.datasource)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.method || "coreset" === input.method || "random" === input.method) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.objectLevel || "object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) && $io3(input.objectLevel)) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io4(input.stoppingCondition)) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport);
            const $io1 = (input: any): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold;
            const $io2 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll);
            const $io3 = (input: any): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName)) && (undefined === input.padding || "number" === typeof input.padding && !Number.isNaN(input.padding)) && (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName));
            const $io4 = (input: any): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance && !Number.isNaN(input.minDistance)) && (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV2Docker => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao1(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao2(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.method || "coreset" === input.method || "random" === input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "(\"coreset\" | \"random\" | undefined)",
                    value: input.method
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.objectLevel || ("object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && $ao3(input.objectLevel, _path + ".objectLevel", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.stoppingCondition || ("object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && $ao4(input.stoppingCondition, _path + ".stoppingCondition", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && (0 <= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@minimum 0)",
                    value: input.corruptionThreshold
                })) && (1 >= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@maximum 1)",
                    value: input.corruptionThreshold
                })) || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "(number | undefined)",
                    value: input.corruptionThreshold
                });
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                }));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName)",
                    value: input.cropDatasetName
                })) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "(string | undefined)",
                    value: input.cropDatasetName
                })) && (undefined === input.padding || "number" === typeof input.padding && !Number.isNaN(input.padding) || $guard(_exceptionable, {
                    path: _path + ".padding",
                    expected: "(number | undefined)",
                    value: input.padding
                })) && (undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                }));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance && !Number.isNaN(input.minDistance) || $guard(_exceptionable, {
                    path: _path + ".minDistance",
                    expected: "(number | undefined)",
                    value: input.minDistance
                })) && (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                }));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV2Docker",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV2Docker",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerWorkerConfigV2Docker): string => {
        const $io1 = (input: any): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold;
        const $io2 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll);
        const $io3 = (input: any): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName)) && (undefined === input.padding || "number" === typeof input.padding) && (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName));
        const $io4 = (input: any): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance) && (undefined === input.nSamples || "number" === typeof input.nSamples);
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $tail = (typia.createAssertStringify as any).tail;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${$tail(`${undefined === input.checkpoint ? "" : `"checkpoint":${undefined !== input.checkpoint ? $string(input.checkpoint) : undefined},`}${undefined === input.corruptnessCheck ? "" : `"corruptnessCheck":${undefined !== input.corruptnessCheck ? $so1(input.corruptnessCheck) : undefined},`}${undefined === input.datasource ? "" : `"datasource":${undefined !== input.datasource ? $so2(input.datasource) : undefined},`}${undefined === input.embeddings ? "" : `"embeddings":${undefined !== input.embeddings ? $string(input.embeddings) : undefined},`}${undefined === input.enableTraining ? "" : `"enableTraining":${undefined !== input.enableTraining ? input.enableTraining : undefined},`}${undefined === input.method ? "" : `"method":${undefined !== input.method ? (() => {
            if ("string" === typeof input.method)
                return $string(input.method);
            if ("string" === typeof input.method)
                return "\"" + input.method + "\"";
            $throws({
                expected: "(\"coreset\" | \"random\" | undefined)",
                value: input.method
            });
        })() : undefined},`}${undefined === input.normalizeEmbeddings ? "" : `"normalizeEmbeddings":${undefined !== input.normalizeEmbeddings ? input.normalizeEmbeddings : undefined},`}${undefined === input.outputImageFormat ? "" : `"outputImageFormat":${undefined !== input.outputImageFormat ? $string(input.outputImageFormat) : undefined},`}${undefined === input.objectLevel ? "" : `"objectLevel":${undefined !== input.objectLevel ? $so3(input.objectLevel) : undefined},`}${undefined === input.pretagging ? "" : `"pretagging":${undefined !== input.pretagging ? input.pretagging : undefined},`}${undefined === input.pretaggingUpload ? "" : `"pretaggingUpload":${undefined !== input.pretaggingUpload ? input.pretaggingUpload : undefined},`}${undefined === input.relevantFilenamesFile ? "" : `"relevantFilenamesFile":${undefined !== input.relevantFilenamesFile ? $string(input.relevantFilenamesFile) : undefined},`}${undefined === input.selectedSequenceLength ? "" : `"selectedSequenceLength":${undefined !== input.selectedSequenceLength ? input.selectedSequenceLength : undefined},`}${undefined === input.stoppingCondition ? "" : `"stoppingCondition":${undefined !== input.stoppingCondition ? $so4(input.stoppingCondition) : undefined},`}${undefined === input.uploadReport ? "" : `"uploadReport":${undefined !== input.uploadReport ? input.uploadReport : undefined}`}`)}}`;
        const $so1 = (input: any): any => `{${$tail(`${undefined === input.corruptionThreshold ? "" : `"corruptionThreshold":${undefined !== input.corruptionThreshold ? input.corruptionThreshold : undefined}`}`)}}`;
        const $so2 = (input: any): any => `{${$tail(`${undefined === input.bypassVerify ? "" : `"bypassVerify":${undefined !== input.bypassVerify ? input.bypassVerify : undefined},`}${undefined === input.enableDatapoolUpdate ? "" : `"enableDatapoolUpdate":${undefined !== input.enableDatapoolUpdate ? input.enableDatapoolUpdate : undefined},`}${undefined === input.processAll ? "" : `"processAll":${undefined !== input.processAll ? input.processAll : undefined}`}`)}}`;
        const $so3 = (input: any): any => `{${$tail(`${undefined === input.cropDatasetName ? "" : `"cropDatasetName":${undefined !== input.cropDatasetName ? $string(input.cropDatasetName) : undefined},`}${undefined === input.padding ? "" : `"padding":${undefined !== input.padding ? input.padding : undefined},`}${undefined === input.taskName ? "" : `"taskName":${undefined !== input.taskName ? $string(input.taskName) : undefined}`}`)}}`;
        const $so4 = (input: any): any => `{${$tail(`${undefined === input.minDistance ? "" : `"minDistance":${undefined !== input.minDistance ? input.minDistance : undefined},`}${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerWorkerConfigV2DockerValidatorShape = {
    'checkpoint': yup.string(),
    'corruptnessCheck': DockerWorkerConfigV3DockerCorruptnessCheckValidator.optional().default(undefined),
    'datasource': DockerWorkerConfigV2DockerDatasourceValidator.optional().default(undefined),
    'embeddings': yup.string(),
    'enableTraining': yup.boolean(),
    'method': LightlyDockerSelectionMethodValidator.optional().default(undefined),
    'normalizeEmbeddings': yup.boolean(),
    'outputImageFormat': yup.string(),
    'objectLevel': DockerWorkerConfigV2DockerObjectLevelValidator.optional().default(undefined),
    'pretagging': yup.boolean(),
    'pretaggingUpload': yup.boolean(),
    'relevantFilenamesFile': yup.string(),
    'selectedSequenceLength': yup.number().integer().min(1),
    'stoppingCondition': DockerWorkerConfigV2DockerStoppingConditionValidator.optional().default(undefined),
    'uploadReport': yup.boolean(),
};
export const DockerWorkerConfigV2DockerValidator = yup.object().shape(DockerWorkerConfigV2DockerValidatorShape);
export const DockerWorkerConfigV2DockerStringifyShapeProperties: ObjectSchema['properties'] = {
    'checkpoint': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'corruptnessCheck': DockerWorkerConfigV3DockerCorruptnessCheckStringifyShape,
    'datasource': DockerWorkerConfigV2DockerDatasourceStringifyShape,
    'embeddings': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'enableTraining': {
        'type': 'boolean',
    },
    'method': LightlyDockerSelectionMethodStringifyShape,
    'normalizeEmbeddings': {
        'type': 'boolean',
    },
    'outputImageFormat': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'objectLevel': DockerWorkerConfigV2DockerObjectLevelStringifyShape,
    'pretagging': {
        'type': 'boolean',
    },
    'pretaggingUpload': {
        'type': 'boolean',
    },
    'relevantFilenamesFile': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'selectedSequenceLength': {
        'type': 'integer',
        'minimum': 1,
    } as unknown as fastJSON.IntegerSchema,
    'stoppingCondition': DockerWorkerConfigV2DockerStoppingConditionStringifyShape,
    'uploadReport': {
        'type': 'boolean',
    },
};
export const DockerWorkerConfigV2DockerStringifyShape: ObjectSchema = {
    title: 'DockerWorkerConfigV2Docker Stringifier',
    type: 'object',
    properties: {
        ...DockerWorkerConfigV2DockerStringifyShapeProperties
    },
    required: [],
};
export const DockerWorkerConfigV2DockerStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerWorkerConfigV2DockerStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerWorkerConfigV2DockerStringify: (data: DockerWorkerConfigV2Docker) => string = DockerWorkerConfigV2DockerStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerWorkerConfigV2DockerFromJSON(json: any): DockerWorkerConfigV2Docker {
    return DockerWorkerConfigV2DockerFromJSONTyped(json, false);
}
export function DockerWorkerConfigV2DockerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerWorkerConfigV2Docker {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'checkpoint': !exists(json, 'checkpoint') ? undefined : json['checkpoint'],
        'corruptnessCheck': !exists(json, 'corruptnessCheck') ? undefined : DockerWorkerConfigV3DockerCorruptnessCheckFromJSON(json['corruptnessCheck']),
        'datasource': !exists(json, 'datasource') ? undefined : DockerWorkerConfigV2DockerDatasourceFromJSON(json['datasource']),
        'embeddings': !exists(json, 'embeddings') ? undefined : json['embeddings'],
        'enableTraining': !exists(json, 'enableTraining') ? undefined : json['enableTraining'],
        'method': !exists(json, 'method') ? undefined : LightlyDockerSelectionMethodFromJSON(json['method']),
        'normalizeEmbeddings': !exists(json, 'normalizeEmbeddings') ? undefined : json['normalizeEmbeddings'],
        'outputImageFormat': !exists(json, 'outputImageFormat') ? undefined : json['outputImageFormat'],
        'objectLevel': !exists(json, 'objectLevel') ? undefined : DockerWorkerConfigV2DockerObjectLevelFromJSON(json['objectLevel']),
        'pretagging': !exists(json, 'pretagging') ? undefined : json['pretagging'],
        'pretaggingUpload': !exists(json, 'pretaggingUpload') ? undefined : json['pretaggingUpload'],
        'relevantFilenamesFile': !exists(json, 'relevantFilenamesFile') ? undefined : json['relevantFilenamesFile'],
        'selectedSequenceLength': !exists(json, 'selectedSequenceLength') ? undefined : json['selectedSequenceLength'],
        'stoppingCondition': !exists(json, 'stoppingCondition') ? undefined : DockerWorkerConfigV2DockerStoppingConditionFromJSON(json['stoppingCondition']),
        'uploadReport': !exists(json, 'uploadReport') ? undefined : json['uploadReport'],
    };
}
export function DockerWorkerConfigV2DockerToJSON(value?: DockerWorkerConfigV2Docker | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'checkpoint': value.checkpoint,
        'corruptnessCheck': DockerWorkerConfigV3DockerCorruptnessCheckToJSON(value.corruptnessCheck),
        'datasource': DockerWorkerConfigV2DockerDatasourceToJSON(value.datasource),
        'embeddings': value.embeddings,
        'enableTraining': value.enableTraining,
        'method': LightlyDockerSelectionMethodToJSON(value.method),
        'normalizeEmbeddings': value.normalizeEmbeddings,
        'outputImageFormat': value.outputImageFormat,
        'objectLevel': DockerWorkerConfigV2DockerObjectLevelToJSON(value.objectLevel),
        'pretagging': value.pretagging,
        'pretaggingUpload': value.pretaggingUpload,
        'relevantFilenamesFile': value.relevantFilenamesFile,
        'selectedSequenceLength': value.selectedSequenceLength,
        'stoppingCondition': DockerWorkerConfigV2DockerStoppingConditionToJSON(value.stoppingCondition),
        'uploadReport': value.uploadReport,
    };
}
